/* eslint-disable */
import { modalActions } from "@/Actions";
import { Close } from "@mui/icons-material";
import { connect } from "react-redux";
import { BaseModal } from "../BaseModal";

const CustomModal = (props) => {
    const {
        show,
        data,
        toggleCustomModal,
        onClose,
        header,
        subtitle,
        bodyContent,
        actionButtons,
        showCloseButton = true,
        overlayClass = 'bg-black bg-opacity-50',
        modalClass = 'bg-white rounded-lg shadow-xl',
        headerClass = 'border-b px-6 py-2',
        bodyClass = 'p-6',
        footerClass = 'border-t w-full px-6 py-2 flex justify-end space-x-3',
        width = '30rem',
        height = '30rem',
        hideFooter = false,
    } = props;

    if (!show) return null;

    const renderBtns = () => {
        return actionButtons && (
            <div className={footerClass}>
                {Array.isArray(actionButtons)
                    ? actionButtons.map((button, index) => (
                        <button
                            key={index}
                            onClick={button.onClick}
                            className={`px-4 py-2 rounded-md transition-colors ${button.className}`}
                        >
                            {button.label}
                        </button>
                    ))
                    : actionButtons}
            </div>
        )
    }
    const handleClose = () => {
        toggleCustomModal(false)
        if (onClose) onClose();
    }

    const renderCustomHeading = () => {
        if (!header && !subtitle) return null;
        return (
            <div className={`${headerClass} flex flex-col w-full`}>
                <div className='flex justify-between items-center'>
                    {typeof header === 'string' ? (
                        <h3 className="text-lg font-semibold text-gray-900">{header}</h3>
                    ) : header}
                    {showCloseButton && (
                        <button onClick={handleClose} className="text-gray-400 hover:text-gray-500">
                            <Close className="h-6 w-6" />
                        </button>
                    )}
                </div>
                {subtitle && (
                    <p className="flex justify-start w-full text-sm text-gray-500 mt-1">{subtitle}</p>
                )}
            </div>
        );
    };

    return (
        <BaseModal
            open={show}
            handleClose={handleClose}
            renderBtns={renderBtns}
            showClose={false}
            hideFooter={hideFooter}
            width={width}
            height={height}
            customHeading={renderCustomHeading}
        >
            <div className={bodyClass}>
                {typeof bodyContent === 'string' ? (
                    <p className="text-gray-700">{bodyContent}</p>
                ) : bodyContent}
            </div>
        </BaseModal>
    );
};

const mapStateToProps = (state) => {
    const { show, data } = state.modal.customModal;
    return {
        show,
        ...data,
    };
};

const mapDispatchToProps = {
    toggleCustomModal: modalActions.toggleCustomModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);
